import con from '../../../../connection';

const path = '/auth';

const auth = (url: string) => () => {
  return {
    post: (param: { token: string }) =>
      con.post<{
        header: {
          status: string;
          status_code: number;
          messages: string[];
        };
        body: {
          data: {
            member_id: string;
            email: string;
            company_code: string;
            company_name: string;
            organization_name: string;
            token: string;
            kind: boolean;
          };
        };
      }>(url + path, param),
  };
};

export default auth;
